import { Modal } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import type { IButtonProps } from '@/DesignSystem/Model/DataModel';
import { showVideoLoginModal } from '@/Module/Auth/Store/Slice/AuthSlice';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import { IconCrossMark } from '@/Module/Icon';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
interface ILessonDetailUserLoginModalProps {
  onClick?: IButtonProps['onClick'];
}
const LessonDetailUserLoginModal: FC<ILessonDetailUserLoginModalProps> = ({
  onClick
}) => {
  const router = useRouter();
  const isMobile = useDeviceType();
  const dispatch = useAppDispatch();
  const showModal = useAppSelector(state => state.auth.watchVideoNeedLoginModalIsOpen);
  const redirectLink = `${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`;
  return <Modal opened={showModal} size="auto" centered onClose={() => {}} overlayProps={{
    className: '',
    style: {
      backdropFilter: '#0e4791'
    },
    backgroundOpacity: 0.35,
    blur: 9
  }} withCloseButton={false} classNames={{
    root: 'bg-[rgba(14, 71, 145, 0.25)] ',
    body: 'p-0'
  }} data-sentry-element="Modal" data-sentry-component="LessonDetailUserLoginModal" data-sentry-source-file="LessonDetailUserLoginModal.tsx">
      <div className="relative">
        <Link href={redirectLink} onClick={onClick as any} data-sentry-element="Link" data-sentry-source-file="LessonDetailUserLoginModal.tsx">
          <Image alt="برای دسترسی نامحدود وارد شوید" src={isMobile === DeviceType.MOBILE ? `${FILE_BROWSER_URL}/img/img-video-lock-login-mobile.webp` : `${FILE_BROWSER_URL}/img/img-video-lock-login-desktop.webp`} width={isMobile === DeviceType.MOBILE ? 370 : 1396} height={isMobile === DeviceType.MOBILE ? 559 : 718} className="z-0" data-sentry-element="Image" data-sentry-source-file="LessonDetailUserLoginModal.tsx" />
        </Link>

        <Button size="small" radius="circle" variant="shadow" color="white" onClick={() => {
        dispatch(showVideoLoginModal(false));
      }} iconButton className="!absolute left-6 top-6 z-10 bg-white shadow-modalClose md:left-8 md:top-8" data-sentry-element="Button" data-sentry-source-file="LessonDetailUserLoginModal.tsx">
          <IconCrossMark data-sentry-element="IconCrossMark" data-sentry-source-file="LessonDetailUserLoginModal.tsx" />
        </Button>
      </div>
    </Modal>;
};
export default LessonDetailUserLoginModal;